import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=46380384&scoped=true&"
import script from "./Partners.vue?vue&type=script&lang=js&"
export * from "./Partners.vue?vue&type=script&lang=js&"
import style0 from "./Partners.vue?vue&type=style&index=0&id=46380384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46380384",
  null
  
)

export default component.exports